import { DocumentTemplateResponse } from 'src/app/models/documentlibrary/documentLibraryResponse';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseListResponse, BaseModel } from 'src/app/models/BaseModel';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private apiUrl = environment.apiConfig.uri+ '/api/document';

  constructor(private http: HttpClient) { }
  getDocumentList(page : number, limit: number, sortColumn : string): Observable<BaseModel<BaseListResponse<DocumentTemplateResponse>>> {
    return this.http.get<BaseModel<BaseListResponse<DocumentTemplateResponse>>>(`${this.apiUrl}/query/${page}/${limit}?sort=${sortColumn}`);
  }

  getRegisterForm(): Observable<BaseModel<DocumentTemplateResponse>> {
    return this.http.get<BaseModel<DocumentTemplateResponse>>(`${this.apiUrl}/registerForm`);
  }
}
